// src/components/Explore/filters/FilterDropdown.jsx
// Reusable dropdown filter component

import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';
import styles from './FilterDropdown.module.css';

const FilterDropdown = ({
  label,
  icon: Icon,
  value,
  options,
  onChange,
  placeholder = 'Select...',
  showCount = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Find selected option label
  const selectedOption = options.find(opt => opt.value === value);
  const displayValue = selectedOption?.label || placeholder;
  const isDefaultValue = !value || value === options[0]?.value;

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div 
      className={`${styles.filterDropdown} ${className} ${isOpen ? styles.open : ''} ${!isDefaultValue ? styles.active : ''}`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className={styles.dropdownTrigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        {Icon && <Icon className={styles.icon} />}
        <span className={styles.label}>{displayValue}</span>
        <FaChevronDown className={`${styles.chevron} ${isOpen ? styles.rotated : ''}`} />
      </button>

      {isOpen && (
        <div className={styles.dropdownMenu} role="listbox">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`${styles.option} ${value === option.value ? styles.selected : ''}`}
              onClick={() => handleSelect(option.value)}
              role="option"
              aria-selected={value === option.value}
            >
              <span className={styles.optionLabel}>{option.label}</span>
              {showCount && option.count !== undefined && (
                <span className={styles.optionCount}>({option.count})</span>
              )}
              {value === option.value && (
                <FaCheck className={styles.checkIcon} />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;










